import { Item } from 'components/CollabItem/Item'
import { ReactComponent as ThreeDotsIcon } from 'assets/icons/threeDots.svg'
import { ReactComponent as EditIcon } from 'assets/icons/edit16.svg'
import { ReactComponent as TrashIcon } from 'assets/icons/trash16.svg'
import { MenuTrigger } from 'components/MenuTrigger/MenuTrigger'
import { IconButton } from 'components/IconButton/IconButton'
import { Menu } from 'components/Menu/Menu'
import { Item as MenuItem } from '@react-stately/collections'
import ItemStyles from 'components/CollabItem/CollabItem.module.scss'
import { ActionMenuControlProps } from './Types'
import { Key } from 'react'
import { useCollabItemContext } from 'components/CollabItem/CollabItem'
import { useTrackedChangeCommentPermissions } from '../../useTrackedChangeCommentPermissions'
import { useDocStore } from 'stores/DocStore'
import { useDeleteTrackedChangeComment } from 'hooks/queries/trackedChangeComments/useDeleteTrackedChangeComment'

const ActionMenuControl = ({ comment, articleKey, layerId }: ActionMenuControlProps) => {
  const docStore = useDocStore()
  const { setEditing } = useCollabItemContext()
  const { canEdit, canDelete } = useTrackedChangeCommentPermissions(comment)
  const disabledKeys = new Set<string>()
  if (!canEdit) disabledKeys.add('edit')
  if (!canDelete) disabledKeys.add('delete')

  const { mutate: deleteComment } = useDeleteTrackedChangeComment({
    articleKey,
    layerId,
    trackedChangeId: comment.tracked_change_id,
    id: comment.id,
  })

  if (!canEdit && !canDelete) {
    return null
  }

  const handleAction = (action: Key) => {
    switch (action) {
      case 'edit':
        setEditing({ type: 'TrackedChangeComment', id: comment.id })
        docStore.trackedChangesStore.select(comment.tracked_change_id)
        break
      case 'delete':
        deleteComment({})
        break
    }
  }

  return (
    <Item.Control tooltipTitle="More options">
      <MenuTrigger placement="bottom-end">
        <IconButton className={ItemStyles.controlItem} icon={ThreeDotsIcon} title="More actions" />
        <Menu aria-label="More actions" disabledKeys={disabledKeys} onAction={handleAction}>
          <MenuItem key="edit" textValue="Edit">
            <EditIcon />
            Edit
          </MenuItem>
          <MenuItem key="delete" textValue="Delete">
            <TrashIcon />
            Delete
          </MenuItem>
        </Menu>
      </MenuTrigger>
    </Item.Control>
  )
}

export { ActionMenuControl }
